//#region Import
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { numberWithCommas } from '../../../../utils/consts/index';
import { fileHandlerUrl } from '../../../../utils/consts/server';
import momentjs from 'moment-jalaali';
import propTypes from 'prop-types';
import './calendarPrice.scss';

import {
  returnWeeekDay,
  returnDateWithMonthName,
  returnDayAndMonthName,
  returnShamsiDayWithMonthName,
  returnDayWithMonthName,
  returnShamsiDate,
  returnAirlineLogos,
} from '../../../../utils/utility/booking';
import {
  DownIcon,
  UpFillIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  PerviouseIcon,
  DownArrowIcon,
  NextIcon,
} from '~svg/index';

//#endregion
class CalendarPrice extends Component {
  constructor(props) {
    super(props);
  }
  //get last data for flights if props change
  UNSAFE_componentWillReceiveProps = (nextprops) => {
    if (!Object.is(this.props, nextprops))
      this.setState({
        flightList: nextprops?.filterFlightList || nextprops?.flightList,
      });
  };
  //#region usefull Function
  // color the header of matrix when hover on each date in matrixs to show the departure date and destination date in header
  colorMatrixHeader = (i, j) => {
    this.setState({ activeRow: i, activeCoulmn: j });
  };
  //#endregion

  //#region  Render
  renderLogos = (airlineCode) => {
    try {
      return `${fileHandlerUrl}/icons/airlines/${airlineCode}.png`;
    } catch (error) {
      return `${fileHandlerUrl}/icons/airlines/Airplane.png`;
    }
  };
  renderAirlineLogos(airLines = []) {
    let { direction } = this.props.language;
    let operatingAirline = [
      ...new Map(airLines?.map((item) => [item, item])).values(),
    ];
    if (operatingAirline?.length) {
      return (
        // <div className="d-flex flex-column align-items-center justify-content-center px-1">
        <div className="d-flex flex-row align-items-center justify-content-center w-100  position-relative">
          {operatingAirline.map((item, index) => {
            let position = -25 * index;
            return (
              <img
                key={`img-${index}`}
                style={{
                  width: 25,
                  hight: 25,
                  zIndex: operatingAirline.length - index,
                  marginRight:
                    direction === 'ltr'
                      ? operatingAirline.length === 1 || index === 0
                        ? '0px'
                        : `${position}px`
                      : '0px',
                  marginLeft:
                    direction === 'rtl'
                      ? operatingAirline.length === 1 || index === 0
                        ? '0px'
                        : `${position}px`
                      : '0px',
                }}
                title={item}
                className={`d-flex justify-content-center rounded-circle bg-white border border-1 ${
                  index === 0 ? '' : 'position-absolute'
                }
                   
                   `}
                src={this.renderLogos(item)}
                alt="airline operating"
              />
            );
          })}
        </div>

        // </div>
      );
    }
  }
  render() {
    let { rowCount, calendarPrice, counter, parsedQueryStr } = this.props;
    if (calendarPrice?.length) {
      let { name, direction } = this.props.language,
        selectedAirport = JSON.parse(sessionStorage.getItem('selectedAirport')),
        calanderPriceLst =
          parsedQueryStr.ft.toLowerCase() === 'roundtrip' && rowCount > 2
            ? calendarPrice > 0
              ? calendarPrice
              : '--'
            : calendarPrice
                .filter((calc) => calc.Date[1] == parsedQueryStr.d2)
                .slice(0, 7).length
            ? calendarPrice
                .filter((calc) => calc.Date[1] == parsedQueryStr.d2)
                .slice(0, 7)
            : calendarPrice.reduce(
                (first, current) =>
                  first.some((unique) => unique.Date[0] === current.Date[0])
                    ? first
                    : [...first, current],
                [],
              );
      //just show matrix in round trip and show all matrix clicked
      if (parsedQueryStr.ft.toLowerCase() === 'roundtrip' && rowCount > 2)
        return (
          <React.Fragment>
            <div
              className={`d-md-flex  d-md-block d-none  w-100 pt-2 ${
                name === 'fa' ? 'pr-3' : 'pl-3'
              }`}
            >
              <div
                className="d-flex align-items-center w-100 justify-content-start cursor-pointer "
                onClick={() => this.props.showAllMatrix(rowCount)}
              >
                {rowCount === 2 ? (
                  <DownIcon size={16} color="#6c757d" />
                ) : (
                  <UpFillIcon size={16} />
                )}

                <span className="p-1 font-weight-bold font-smaller text-captalize d-flex align-items-center">
                  <FormattedMessage
                    id={
                      rowCount === 2
                        ? 'booking.showallcalendar'
                        : 'booking.hideallcalendar'
                    }
                    defaultMessage={
                      rowCount === 2
                        ? 'booking.showallcalendar'
                        : 'booking.hideallcalendar'
                    }
                  />
                </span>
              </div>
            </div>
            {/* create matrix for calendar price */}
            <div className="flex-column d-flex align-items-center justify-content-center">
              <div className={`w-100 ${name === 'fa' ? 'pr-3' : 'pl-3'}`}>
                <div
                  className={`d-flex justify-content-center flex-column w-100`}
                >
                  <div className="d-flex w-100 " key={`row`}>
                    <div
                      className="border border-2  border-primary-light  font-small  p-2 m-0 text-captalize font-weight-bold mx-1 "
                      style={{
                        width: '12.5%',
                        height: '8vh',
                        borderRadius: 9,
                      }}
                    >
                      <div
                        className={`${
                          name !== 'fa' ? 'text-right' : 'text-left'
                        } font-smaller px-1 `}
                      >
                        <div className="justify-content-between  align-items-center d-flex font-smaller text-primary ">
                          <div className="align-items-start justify-content-center  d-flex ">
                            <div className=" d-flex align-items-center  font-smaller ">
                              <FormattedMessage
                                id="booking.return"
                                defaultMessage="booking.return"
                              />
                            </div>
                          </div>
                          <div className="d-flex justify-content-end align-items-center text-primary font-smaller">
                            <span className="mx-1">
                              <FormattedMessage
                                id="booking.departure"
                                defaultMessage="booking.departure"
                              />
                            </span>
                            {name !== 'fa' ? (
                              <PerviouseIcon color="#aaacaf" size={12} />
                            ) : (
                              <NextIcon color="#aaacaf" size={12} />
                            )}
                          </div>
                        </div>
                        <div className="d-flex align-items-center px-3">
                          <div
                            className={`d-flex align-items-cente ${
                              name !== 'fa' ? 'pr-1' : 'pl-1'
                            } `}
                          >
                            <DownArrowIcon size={12} color="#6c757d" />
                          </div>
                        </div>
                      </div>
                    </div>
                    {Array.from({ length: 7 }).map((v, j) => {
                      {
                        return (
                          <div
                            key={`cal-${j}`}
                            onClick={() =>
                              this.props.changeDate(
                                calendarPrice[j * 7].Date[0],
                                calendarPrice[j * 7].Date[1],
                              )
                            }
                            className={`d-flex border border-2  border-primary-light  p-2  mx-1 justify-content-between align-items-center cursor-pointer ${
                              this.state.activeCoulmn === j
                                ? 'bg-gray-light'
                                : ''
                            }`}
                            style={{
                              borderRadius: 9,
                              height: '8vh',
                              width: '12.5%',
                            }}
                          >
                            <div className="d-flex align-items-center justify-content-center font-weight-bold text-dark font-xsmall px-1">
                              {returnWeeekDay(
                                calendarPrice[j * 7].Date[0],
                                name,
                                false,
                              )}
                            </div>
                            <div className="font-weight-bold text-secondary-dark  font-xsmall pt-1  d-flex align-items-center justify-content-around flex-column px-1">
                              <div
                                className={`d-flex ${
                                  this.state.activeCoulmn === j
                                    ? 'text-primary'
                                    : 'text-primary-light'
                                }`}
                              >
                                {direction === 'rtl'
                                  ? returnShamsiDate(
                                      calendarPrice[j * 7].Date[0],
                                      name,
                                    )
                                  : ''}
                              </div>

                              <div
                                className={`
                                  text-darkGray `}
                              >
                                {returnDateWithMonthName(
                                  calendarPrice[j * 7].Date[0],
                                  name,
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                  {/* show all matrix date */}
                  {rowCount > 2 &&
                    calendarPrice &&
                    calendarPrice.length &&
                    Array.from({
                      length: rowCount,
                    }).map((v, i) => {
                      return (
                        <div className="d-flex mt-1 w-100 " key={`row-${i}`}>
                          {
                            <div
                              key={`column-${i}`}
                              className={`border border-2 border-primary-light p-2 mx-1  d-flex align-items-center justify-content-between ${
                                this.state.activeRow === i
                                  ? 'bg-select-matrix'
                                  : // : i % 2 !== 0
                                    // ? ""
                                    ''
                                // bg-light-third
                              }`}
                              style={{
                                borderRadius: 9,
                                height: '8vh',
                                width: '12.5%',
                              }}
                            >
                              <div
                                className={`font-weight-bold text-dark font-xsmall  `}
                              >
                                {returnWeeekDay(
                                  calendarPrice[i].Date[1],
                                  name,
                                  false,
                                )}
                              </div>
                              <div className="font-weight-bold  font-xsmall pt-1  d-flex align-items-center justify-content-between flex-column px-1">
                                <div
                                  className={`flex  ${
                                    this.state.activeRow === i
                                      ? 'text-primary'
                                      : 'text-primary-light'
                                  }`}
                                >
                                  {direction === 'rtl'
                                    ? returnShamsiDate(
                                        calendarPrice[i].Date[1],
                                        name,
                                      )
                                    : ''}
                                </div>
                                <div className={` text-darkGray  `}>
                                  {calendarPrice[i].Date[1]}
                                </div>
                              </div>
                            </div>
                          }
                          {Array.from({
                            length: 7,
                          }).map((v, j) => {
                            let UniqAirlineCode =
                              calendarPrice[j * 7 + i] &&
                              calendarPrice[j * 7 + i].AirlineCode &&
                              calendarPrice[j * 7 + i].AirlineCode.length
                                ? [
                                    ...new Set(
                                      calendarPrice[j * 7 + i].AirlineCode,
                                    ),
                                  ]
                                : [];

                            {
                              return (
                                <div
                                  key={`TicketPrice${i}-${j}`}
                                  onMouseOver={() =>
                                    this.colorMatrixHeader(i, j)
                                  }
                                  onMouseLeave={() =>
                                    this.colorMatrixHeader(-1, -1)
                                  }
                                  onClick={() =>
                                    calendarPrice[j * 7 + i].Date[0] <=
                                    calendarPrice[i].Date[1]
                                      ? this.props.changeDate(
                                          calendarPrice[j * 7 + i].Date[0],
                                          calendarPrice[i].Date[1],
                                        )
                                      : null
                                  }
                                  id={`TicketPrice${i}-${j}`}
                                  className={`border border-2 border-primary-light p-2 font-weight-bold  mx-1 d-flex align-items-center justify-content-between font-xsmall cursor-pointer ${
                                    calendarPrice[j * 7 + i].AdultPrice === 0
                                      ? // bg-creamy
                                        ' text-dark cursor-pointer'
                                      : calendarPrice[j * 7 + i].Date[0] ===
                                          selectedAirport[0].date.miladi.join(
                                            '-',
                                          ) &&
                                        calendarPrice[i].Date[1] ===
                                          selectedAirport[
                                            selectedAirport.length - 1
                                          ].date.miladi.join('-')
                                      ? 'bg-primary-light text-white cursor-pointer'
                                      : `calendarPrice cursor-pointer `
                                    // (j + i) % 2 === 0 ? "" : ""
                                    // "bg-light-third"
                                  }
                          `}
                                  style={{
                                    borderRadius: 9,
                                    width: '12.5%',
                                    height: '8vh',
                                  }}
                                >
                                  <div className="d-flex flex-column align-items-around justify-content-around w-100">
                                    <div className="d-flex align-items-around justify-content-between">
                                      {/* <div className="d-flex justify-content-cenetr align-items-center text-primary">
                                        {UniqAirlineCode &&
                                        UniqAirlineCode.length > 1 ? (
                                          <FormattedMessage id="booking.multiairline" />
                                        ) : calendarPrice[j * 7 + i]
                                            .AirlineName &&
                                          calendarPrice[j * 7 + i].AirlineName
                                            .length > 0 ? (
                                          calendarPrice[j * 7 + i]
                                            .AirlineName[0]
                                        ) : (
                                          "--"
                                        )}
                                      </div> */}
                                      <div className="d-flex justify-content-cenetr align-items-center">
                                        {this.renderAirlineLogos(
                                          calendarPrice[j * 7 + i].AirlineCode,
                                        )}
                                      </div>
                                      <div className="d-flex justify-content-cenetr align-items-center ">
                                        {calendarPrice[j * 7 + i].AdultPrice
                                          ? numberWithCommas(
                                              (
                                                calendarPrice[j * 7 + i]
                                                  .AdultPrice / 10
                                              ).toFixed(0),
                                            )
                                          : ''}
                                      </div>
                                    </div>
                                    {/* <div className="d-flex justify-content-center align-items-center pt-2 text-third text-underline">
                                      سایر پروازها
                                    </div> */}
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      );
                    })}
                </div>
              </div>
              {/* show hint for money unit */}
              {/* <div className="d-flex flex-row w-100 justify-content-end pt-1">
                <div className="d-flex align-items-center">
                  <span className="px-1 text-darkGray font-tiny fas fa-star-of-life  text-darkGray" />
                  <span className="font-weight-bold text-secondary font-small px-1 ">
                    <FormattedMessage
                      id="booking.allprice"
                      defaultMessage="booking.allprice"
                    />
                  </span>
                </div>
              </div> */}
            </div>
          </React.Fragment>
        );
      // show calendar price for one way trip
      else
        return (
          <>
            <div className={`d-md-flex  d-md-block d-none`}>
              {parsedQueryStr.ft.toLowerCase() === 'roundtrip' && (
                <div className="d-flex align-items-center justify-content-start ">
                  <div
                    className="d-flex align-items-center  px-0 justify-content-end cursor-pointer py-2"
                    onClick={() => this.props.showAllMatrix(rowCount)}
                  >
                    {rowCount === 2 ? (
                      <DownIcon size={16} color="#6c757d" />
                    ) : (
                      <UpFillIcon size={16} color="#6c757d" />
                    )}

                    <span className="px-1 font-weight-bold font-smaller text-captalize">
                      <FormattedMessage
                        id={
                          rowCount === 2
                            ? 'booking.showallcalendar'
                            : 'booking.hideallcalendar'
                        }
                        defaultMessage={
                          rowCount === 2
                            ? 'booking.showallcalendar'
                            : 'booking.hideallcalendar'
                        }
                      />
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div
              className={`card border-0 w-100 bg-primary text-white default-border-radius mt-lg-0 mt-2`}
            >
              <div className="card-body px-2 py-md-2 py-3 position-relative">
                <div
                  className={`d-flex align-items-center cursor-pointer position-absolute ${
                    direction === 'rtl'
                      ? 'arrow-right-calendar'
                      : 'arrow-left-calendar'
                  }`}
                  onClick={() =>
                    counter < 1 ? null : this.props.setCounter('minus')
                  }
                >
                  <div
                    className={`slider-arrow ${
                      counter < 1 && 'arrow-disabled'
                    }`}
                  >
                    {direction !== 'rtl' ? (
                      <ChevronRightIcon
                        size={32}
                        color="#fff"
                        variant="svg-sm-large svg-xs-large svg-smaller svg-md-large"
                      />
                    ) : (
                      <ChevronLeftIcon
                        size={32}
                        color="#fff"
                        variant="svg-sm-large svg-xs-large svg-smaller svg-md-large"
                      />
                    )}
                  </div>
                </div>
                <div
                  className={`d-flex align-items-center cursor-pointer position-absolute   ${
                    direction === 'rtl'
                      ? 'arrow-left-calendar'
                      : 'arrow-right-calendar'
                  }`}
                  onClick={() =>
                    counter > 7 ? null : this.props.setCounter('plus')
                  }
                >
                  {direction !== 'ltr' ? (
                    <ChevronLeftIcon
                      color="#fff"
                      size={32}
                      variant="svg-sm-large svg-xs-large svg-smaller svg-md-large"
                    />
                  ) : (
                    <ChevronRightIcon
                      color="#fff"
                      size={32}
                      variant="svg-sm-large svg-xs-large svg-smaller svg-md-large"
                    />
                  )}
                </div>
                <ul
                  className={`w-100 h-100 d-flex ${
                    name === 'fa' ? 'upper-cal-border-fa' : 'upper-cal-border'
                  } upper-cal p-0 m-0`}
                >
                  {calanderPriceLst.map((item, index) => {
                    return (
                      <li
                        key={`cal-${index}`}
                        style={{ float: name === 'fa' ? 'right' : 'left' }}
                        onClick={() =>
                          this.props.changeDate(
                            item.Date[0].split('T')[0],
                            item.Date[1] ? item.Date[1].split('T')[0] : '',
                          )
                        }
                        className="cursor-pointer"
                      >
                        <div
                          style={{
                            borderRadius:
                              direction === 'ltr'
                                ? index === 0
                                  ? '2rem 0rem 0rem 2rem'
                                  : index === calanderPriceLst.length - 1
                                  ? '0rem 2rem 2rem 0rem'
                                  : ''
                                : index === 0
                                ? '0rem 2rem 2rem 0rem'
                                : index === calanderPriceLst.length - 1
                                ? '2rem 0rem 0rem 2rem'
                                : '',
                          }}
                          className={`w-100 h-100  font-weight-bold font-xsmall font-md-smaller py-1 ${
                            item.Date &&
                            item.Date.length &&
                            item.Date[0].split('T')[0] === parsedQueryStr.d1
                              ? ' text-secondary-light '
                              : ' text-white'
                          }`}
                        >
                          {this.props.flightType === 'roundtrip' ? (
                            <div className="d-flex flex-column  ">
                              <div className="d-md-flex d-sm-none d-none d-md-block justify-content-center font-weight-bold ">
                                {returnWeeekDay(
                                  item.Date[0].split('T')[0],
                                  this.props.language.name === 'fa'
                                    ? 'fa'
                                    : 'en',
                                  false,
                                )}
                              </div>
                              <div className="d-md-flex justify-content-center py-3 d-sm-none d-none d-md-block font-weight-bold">
                                {returnDayAndMonthName(
                                  item.Date[0].split('T')[0],
                                  this.props.language.name === 'fa'
                                    ? 'fa'
                                    : 'en',
                                )}
                                -
                                {returnDayAndMonthName(
                                  item.Date[1].split('T')[0],
                                  this.props.language.name === 'fa'
                                    ? 'fa'
                                    : 'en',
                                )}
                              </div>
                              <div className="d-flex  flex-column align-items-center justify-content-center   py-md-3 d-sm-block d-block d-md-none">
                                <div>
                                  {returnDayAndMonthName(
                                    item.Date[0].split('T')[0],
                                    this.props.language.name === 'fa'
                                      ? 'fa'
                                      : 'en',
                                  )}
                                </div>
                                <div className="pt-3 pt-md-0">
                                  {returnDayAndMonthName(
                                    item.Date[1].split('T')[0],
                                    this.props.language.name === 'fa'
                                      ? 'fa'
                                      : 'en',
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex flex-column ">
                              <div className="d-flex justify-content-center ">
                                {returnWeeekDay(
                                  item.Date[0].split('T')[0],
                                  name,
                                  false,
                                )}
                              </div>
                              <div className="d-flex justify-content-center pt-1">
                                <div>
                                  {name === 'fa'
                                    ? `${returnShamsiDayWithMonthName(
                                        momentjs(
                                          item.Date[0].split('T')[0],
                                          'YYYY-M-D',
                                        ).format('jYYYY-jMM-jDD'),
                                        name,
                                      )}`
                                    : ''}
                                </div>
                                <div className="d-sm-none d-none d-md-block">
                                  {name === 'fa' ? <span>,</span> : <></>}
                                  {`${returnDayWithMonthName(
                                    item.Date[0].split('T')[0],
                                    name,
                                  )}`}
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="justify-content-center align-items-center d-flex flex-column  px-2 ">
                            {((parsedQueryStr.ft.toLowerCase() ===
                              'roundtrip' &&
                              this.props.rowCount === 2) ||
                              parsedQueryStr.ft.toLowerCase() !==
                                'roundtrip') &&
                              (this.props.calendarPrice.every(
                                (t) => t.AdultPrice === 0,
                              ) ? (
                                <span
                                  className={` font-weight-bold font-large text-gold`}
                                >
                                  --
                                </span>
                              ) : // <img
                              //   className="rounded-circle"
                              //   src={require("../../../../content/images/icon/calendar-loading.gif")}
                              //   alt=""
                              // />
                              item.AdultPrice > 0 ? (
                                <span
                                  className={` font-weight-bold py-1 ${
                                    item.Date[0].split('T')[0] ===
                                    parsedQueryStr.d1
                                      ? 'font-xsmall font-md-normal text-secondary-light'
                                      : 'font-xsmall font-md-normal text-gold '
                                  } `}
                                >
                                  {/* {item.AdultPrice > 0
                              ? numberWithCommas(
                                  (item.AdultPrice / 260000).toFixed(2)
                                )
                              : "--"} */}
                                  {numberWithCommas(
                                    (item.AdultPrice / 10).toFixed(0),
                                  )}
                                </span>
                              ) : (
                                <span
                                  className={` font-weight-bold font-normal font-md-large text-gold`}
                                >
                                  --
                                </span>
                              ))}
                            <img
                              className="d-none d-md-flex align-items-center justify-content-center bg-white border border-1 p-1 rounded-circle"
                              width={32}
                              height={32}
                              src={returnAirlineLogos(item.AirlineCode[0])}
                              alt="Airplane"
                            />
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </>
        );
    } else return <></>;
  }
  //#endregion
}
function mapStateToProps(state, props) {
  return { language: state.language };
}
//#region  proptypes
CalendarPrice.propTypes = {
  rowCount: propTypes.number,
  counter: propTypes.number,
  setCounter: propTypes.func,
  showAllMatrix: propTypes.func,
  calendarPrice: propTypes.array,
  parsedQueryStr: propTypes.object,
  changeDate: propTypes.func,
};
//#endregion
//#region  proptypes
CalendarPrice.defaultProps = {
  rowCount: 2,
  counter: 1,
  setCounter: () => {
    console.error("calendarPrice component hasn't setCounter function");
  },
  showAllMatrix: () => {
    console.error("calendarPrice component hasn't showAllMatrix function");
  },
  calendarPrice: [],

  parsedQueryStr: {},
  changeDate: () => {
    console.error("calendarPrice component hasn't changeDate function");
  },
};
//#endregion
export default injectIntl(connect(mapStateToProps)(CalendarPrice));
